import useRootIssuer from "components/company/v3/context/hooks/useRootIssuer";
import { getAmplitudeTabContentInfo } from "components/company/v3/utils/getAmplitudeTabContentInfo";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { useEffect } from "react";

interface WrapperAmplitudeCompanyPageProps {
  category: string;
  tickerSymbol: string;
  children: React.ReactElement;
}

export function WrapperAmplitudeCompanyPage({ category, tickerSymbol, children }: WrapperAmplitudeCompanyPageProps) {
  const amplitude = useAmplitude();
  const issuer = useRootIssuer();

  const isFiis = issuer.__typename === "BrazilianRealEstateFund";

  useEffect(() => {
    amplitude.logEvent("Viewed issuer", {
      category,
      issuerId: issuer._id,
      tickerSymbol: tickerSymbol.toUpperCase(),
      name: issuer.name,
      sector: isFiis ? issuer.selfRegulation.primarySegment : issuer.sector,
    });
  }, [issuer._id]);

  return children;
}

interface WrapperAmplitudeCompanyTabProps {
  category: string;
  tab: string;
  tickerSymbol: string;
  children: React.ReactElement;
}

export function WrapperAmplitudeCompanyTab({ category, tab, tickerSymbol, children }: WrapperAmplitudeCompanyTabProps) {
  const amplitude = useAmplitude();
  const issuer = useRootIssuer();

  const isFiis = issuer.__typename === "BrazilianRealEstateFund";

  useEffect(() => {
    amplitude.logEvent("Viewed issuer tab", {
      category,
      issuerId: issuer._id,
      tickerSymbol: tickerSymbol.toUpperCase(),
      name: issuer.name,
      sector: isFiis ? issuer.selfRegulation.primarySegment : issuer.sector,
      ...getAmplitudeTabContentInfo(tab),
    });
  }, [issuer._id, tab]);

  return children;
}
